import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcorporatecabserviceinbanglore() {



  const cardData =
  {
    keyword: ' Outstation Corporate Cab Service in Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Outstation Corporate Cab Service in Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Outstation Corporate Cab Service in Bangalore, catering to the long-distance travel needs of corporate employees, clients, and executives. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for business trips, client visits, conferences, and corporate events across cities. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, we deliver seamless and hassle-free mobility solutions for outstation travel. Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in the 19th century, is inspired by England’s Windsor Castle and showcases Tudor-style architecture with fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, making it a hub for history and heritage enthusiasts."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden spans 240 acres and is famous for its diverse flora, centuries-old trees, and iconic glasshouse. It hosts biannual flower shows attracting visitors from across the city. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families seeking relaxation amidst greenery."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a 300-acre urban oasis in central Bangalore featuring lush greenery, walking trails, jogging paths, and playgrounds. It houses statues, government buildings, and botanical features, creating a perfect blend of nature and culture. The park is a popular spot for morning walks, family outings, photography, and leisurely strolls."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building in Bangalore known for its Neo-Dravidian architectural style. It features grand pillars, intricate stone carvings, and massive domes. Though entry is restricted, the majestic facade and surrounding viewpoints provide excellent photo opportunities, and it stands as a symbol of Karnataka’s political and cultural heritage."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple in Bangalore is a spiritual and cultural center dedicated to Lord Krishna. The temple features traditional architecture, vibrant murals, and beautifully landscaped gardens. Visitors can participate in devotional ceremonies, cultural programs, and enjoy vegetarian meals at the temple’s food court, making it a peaceful escape for meditation and spiritual learning."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s busiest shopping destinations, offering clothing, footwear, jewelry, and street food. Locals and tourists flock here for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere and colorful storefronts make it a must-visit for retail enthusiasts and urban explorers."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can see lions, tigers, elephants, and other animals in naturalistic habitats. The park is ideal for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a scenic water body in central Bangalore, popular for boating, photography, and evening strolls. Surrounded by greenery and small islands, it provides a serene spot for relaxation, picnics, and spending quality time with family or friends amidst the city’s bustle."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, located on the outskirts of Bangalore, is a scenic hill station known for breathtaking sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The cool climate, lush landscapes, and panoramic vistas make it a favorite spot for nature lovers, photographers, and adventure seekers looking for a refreshing escape."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla, located near Bangalore, is a top amusement park offering thrilling rides, water slides, and family entertainment zones. It is ideal for a fun-filled day with friends and family, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for both locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "Outstation Taxi Bangalore Corporate",
"description": "Outstation Taxi Bangalore Corporate offers professional long-distance travel services for corporate clients, employees, and executives. The service features well-maintained sedans and SUVs, experienced chauffeurs, real-time tracking, and planned routes for outstation business trips, factory visits, and client meetings. It ensures punctual, safe, and comfortable travel with flexible scheduling and multi-shift support, catering to the diverse needs of Bangalore-based companies requiring interstate and intercity mobility."
},
{
"name": "Business Travel Outstation Bangalore",
"description": "Business Travel Outstation Bangalore provides tailored outstation transport solutions for corporate employees, managers, and clients. Equipped with modern vehicles and professional drivers, the service ensures safe, reliable, and comfortable travel for business trips, intercity meetings, and corporate site visits. It offers GPS tracking, trip planning, and efficient route management, making long-distance corporate travel seamless and stress-free."
},
{
"name": "Employee Outstation Trip Cab",
"description": "Employee Outstation Trip Cab delivers dedicated transportation for employees traveling for business, training, or corporate assignments outside Bangalore. The service ensures timely pickups, secure travel, trained chauffeurs, and well-maintained vehicles. It supports multi-day trips, corporate policies, and provides detailed trip tracking and reporting for efficient workforce mobility."
},
{
"name": "Corporate Highway Travel Bangalore",
"description": "Corporate Highway Travel Bangalore specializes in safe and efficient highway transport for corporate employees and executives. The service includes GPS-enabled vehicles, experienced drivers, pre-planned routes, and multi-vehicle coordination for team travel. It ensures smooth, timely, and reliable long-distance commutes for business meetings, intercity assignments, and corporate tours across Karnataka and neighboring states."
},
{
"name": "Best Outstation Cab Bangalore",
"description": "Best Outstation Cab Bangalore offers premium long-distance travel solutions for corporate clients and executives. With luxury sedans, SUVs, and professional chauffeurs, the service focuses on safety, comfort, and punctuality. It is ideal for senior management, client visits, interstate business trips, and corporate tours requiring high service standards and reliable transport solutions."
},
{
"name": "Affordable Outstation Taxi Bangalore",
"description": "Affordable Outstation Taxi Bangalore provides budget-friendly corporate outstation travel without compromising on safety or comfort. The service is designed for startups, SMEs, and mid-sized companies requiring reliable intercity transport, featuring trained drivers, GPS tracking, and well-maintained sedans and SUVs, ensuring a smooth and cost-effective long-distance travel experience."
},
{
"name": "Sedan Outstation Cab Bangalore",
"description": "Sedan Outstation Cab Bangalore offers premium sedans for corporate employees and executives traveling on intercity trips, airport transfers, and business meetings. Each vehicle is professionally maintained, equipped with modern amenities, and driven by experienced chauffeurs to ensure comfortable, safe, and punctual long-distance travel."
},
{
"name": "SUV Outstation Cab Bangalore",
"description": "SUV Outstation Cab Bangalore provides spacious, comfortable, and durable SUVs for team travel, executive journeys, and corporate outstation trips. With professional chauffeurs, GPS tracking, and safety-compliant vehicles, the service ensures premium intercity transport, ideal for group travel, industrial site visits, and long-distance business commutes."
},
{
"name": "Monthly Outstation Cab Hire",
"description": "Monthly Outstation Cab Hire offers companies long-term solutions for regular employee and executive intercity travel. The service includes dedicated vehicles, professional drivers, flexible monthly plans, real-time tracking, and multi-shift support, ensuring uninterrupted, safe, and reliable corporate mobility across Bangalore and neighboring states."
},
{
"name": "Executive Outstation Cab Bangalore",
"description": "Executive Outstation Cab Bangalore delivers top-tier intercity travel for senior management, clients, and corporate visitors. With luxury vehicles, trained chauffeurs, and GPS-enabled tracking, the service ensures a professional, safe, and comfortable travel experience tailored to executive needs, supporting airport transfers, client meetings, and business tours."
},
{
"name": "Company Outstation Transport",
"description": "Company Outstation Transport provides end-to-end corporate long-distance travel management, including employee pickups, executive trips, and multi-day assignments. The service features professional drivers, well-maintained sedans and SUVs, route optimization, and real-time tracking, ensuring safe, efficient, and organized corporate mobility for intercity travel from Bangalore."
},
{
"name": "Long Distance Corporate Cabs",
"description": "Long Distance Corporate Cabs delivers reliable intercity transportation for employees, managers, and clients. It includes GPS-enabled sedans and SUVs, professional chauffeurs, and planned routes for business trips, interstate meetings, and corporate site visits. The service ensures timely, comfortable, and safe long-distance commutes for corporate organizations."
},
{
"name": "Outstation Chauffeur Service",
"description": "Outstation Chauffeur Service provides trained drivers for corporate intercity trips, airport transfers, and long-distance employee travel. The service guarantees professional driving standards, punctuality, GPS tracking, and well-maintained vehicles, offering a premium and reliable travel experience for business travelers and corporate staff."
},
{
"name": "Interstate Corporate Cab",
"description": "Interstate Corporate Cab offers corporate transport solutions across states, ideal for intercity meetings, factory visits, and executive travel. The service features sedans and SUVs, GPS tracking, experienced chauffeurs, flexible scheduling, and safety compliance, providing efficient and professional long-distance travel for corporate clients based in Bangalore."
},
{
"name": "Business Trip Cabs Bangalore",
"description": "Business Trip Cabs Bangalore delivers end-to-end transport solutions for corporate business trips, including airport transfers, client visits, intercity travel, and team mobility. The service combines comfortable vehicles, professional chauffeurs, GPS-enabled monitoring, and efficient route management, ensuring reliable, safe, and hassle-free travel for corporate employees and executives."
}
],

"tableData": [
["Outstation Taxi Bangalore Corporate", "Business Travel Outstation Bangalore"],
["Employee Outstation Trip Cab", "Corporate Highway Travel Bangalore"],
["Best Outstation Cab Bangalore", "Affordable Outstation Taxi Bangalore"],
["Sedan Outstation Cab Bangalore", "SUV Outstation Cab Bangalore"],
["Monthly Outstation Cab Hire", "Executive Outstation Cab Bangalore"],
["Company Outstation Transport", "Long Distance Corporate Cabs"],
["Outstation Chauffeur Service", "Interstate Corporate Cab"],
["Business Trip Cabs Bangalore", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Outstation Corporate Cab Service in Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable outstation corporate cab services from Bangalore, ensuring comfortable and efficient travel for employees, executives, and business teams."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs for outstation trips, helping corporate travelers reach destinations on time, whether for meetings, conferences, or client visits."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable journey for long-distance corporate trips."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable outstation travel."
  },
  {
    "WhyChooseheading": "Customized Outstation Travel Packages",
    "WhyChoosedescription": "We offer flexible outstation cab rental plans tailored to meet the commuting needs of businesses, executives, and corporate teams."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, route adjustments, and emergencies, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Outstation corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making business travel hassle-free."
  }
]

































  }

const faqData = [
  {
    question: 'Do you provide outstation corporate cab services from Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional outstation corporate cab services from Bangalore to nearby cities and business destinations.',
  },
  {
    question: 'Which outstation locations do you cover from Bangalore?',
    answer: 'We cover major cities and industrial hubs like Mysore, Hosur, Tumkur, Hyderabad, Chennai, Pune, and other corporate destinations.',
  },
  {
    question: 'Do you offer one-way and round-trip outstation corporate cab services?',
    answer: 'Yes, we provide flexible options including one-way, round-trip, and multi-day corporate travel services for employees and executives.',
  },
  {
    question: 'What types of vehicles are available for outstation corporate travel?',
    answer: 'We offer sedans, SUVs, luxury cars, Innova Crysta, tempo travellers, and hatchbacks based on corporate travel needs and group size.',
  },
  {
    question: 'How can companies book outstation corporate cab services from Bangalore?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate travel support team.',
  },
  {
    question: 'Do you provide long-term corporate contracts for outstation travel?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate outstation travel contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are the outstation cabs monitored for safety and tracking?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Can you manage multi-day outstation trips for corporate employees?',
    answer: 'Absolutely. We provide fully managed multi-day outstation trips with driver stay, route planning, and shift management.',
  },
  {
    question: 'What payment options are available for outstation corporate cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Nair',
    feedback: 'Excellent outstation corporate cab service from Bangalore. Comfortable vehicles, punctual drivers, and professional coordination.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Very reliable and convenient for our corporate trips. Smooth communication and well-maintained vehicles for all journeys.',
    rating: 5,
  },
];




































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Corporate Cab Service in Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/outstation-cab-bangalore.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable outstation corporate cab services in Bangalore, including business travel, employee outstation trips, highway travel, long-distance corporate cabs, monthly outstation rentals, executive chauffeur-driven cars, and interstate corporate transport solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/outstation-corporate-cab-bangalore"
  }
};






  return (
    <div>

<Helmet>
  <title>Outstation Corporate Cab Service in Bangalore | Employee & Business Travel</title>

  <meta
    name="description"
    content="Premium outstation corporate cab services in Bangalore including business travel, employee trips, highway travel, long-distance cabs, monthly rentals, executive chauffeur-driven cars, and interstate corporate transport."
  />

  <meta
    name="keywords"
    content="Outstation Taxi Bangalore Corporate, Business Travel Outstation Bangalore, Employee Outstation Trip Cab, Corporate Highway Travel Bangalore, Best Outstation Cab Bangalore, Affordable Outstation Taxi Bangalore, Sedan Outstation Cab Bangalore, SUV Outstation Cab Bangalore, Monthly Outstation Cab Hire, Executive Outstation Cab Bangalore, Company Outstation Transport, Long Distance Corporate Cabs, Outstation Chauffeur Service, Interstate Corporate Cab, Business Trip Cabs Bangalore"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcorporatecabserviceinbanglore;